import firebase from "firebase";

// Initialize Firebase
const config = {
	apiKey: "AIzaSyAv8vQxPywstOcCMZMbytFTLvmLrFYKoNE",
	authDomain: "intelligence-web.firebaseapp.com",
	databaseURL: "https://intelligence-web.firebaseio.com",
	projectId: "intelligence-web",
	storageBucket: "intelligence-web.appspot.com",
	messagingSenderId: "231463304676"
};

firebase.initializeApp(config);
const auth = firebase.auth();
const db = firebase.database();
const storage = firebase.storage();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

export {
	auth,
	db,
	storage,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
